import { useContext } from "react";
import { Tooltip } from "@mui/material";
import { ThemeContext } from "../../context/ThemeContext";
import GlobalIcon from "../GlobalIcon/GlobalIcon";
import styles from "./ThemeToggle.module.css";

function ThemeToggle() {
  const { effectiveTheme, toggleTheme } = useContext(ThemeContext);
  const label = effectiveTheme === "light" ? "Switch to dark mode" : "Switch to light mode";

  return (
    <Tooltip
      title={label}
      arrow
      enterDelay={200}
      slotProps={{
        tooltip: {
          sx: {
            fontFamily: "Inter, sans-serif",
            fontSize: "0.8125rem",
          },
        },
      }}
    >
      <span className={styles["theme-toggle-wrap"]}>
        <button
          type="button"
          className={styles["theme-toggle"]}
          onClick={toggleTheme}
          aria-label={label}
        >
          {effectiveTheme === "light" ? (
            <GlobalIcon iconName="MoonIcon" className={styles["theme-icon"]} />
          ) : (
            <GlobalIcon iconName="SunIcon" className={styles["theme-icon"]} />
          )}
        </button>
      </span>
    </Tooltip>
  );
}

export default ThemeToggle;
